export async function* RAFGenerator(): AsyncGenerator<number, void, void> {
  while (true) {
    yield await new Promise<number>(requestAnimationFrame)
  }
}

export const asyncTimeout = (ms: number) => new window.Promise(res => window.setTimeout(res, ms))

export const asyncConditionCheck = (
  condition: () => boolean,
  repetitions: number = 10,
  ms: number = 1000,
  signal?: AbortSignal
) =>
  new Promise<boolean>(resolve => {
    let i = 0
    const interval = window.setInterval(() => {
      const conditionResult = condition()
      if (conditionResult) {
        window.clearInterval(interval)
        resolve(conditionResult)
      } else if (i >= repetitions) {
        window.clearInterval(interval)
        resolve(conditionResult)
      }
      i++
    }, ms)
    if (signal) {
      signal.addEventListener('abort', () => {
        resolve(false)
        window.clearInterval(interval)
      })
    }
  })
